import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as jexcel from 'jexcel';
import { Auth } from 'src/app/models/auth';
import { CollaboratorType } from 'src/app/models/collaborator-type';
import { PurchaseFile } from 'src/app/models/compra-batch';
import { FormFields } from 'src/app/models/form-field';
import { Group, GroupProduct } from 'src/app/models/group';
import { OpcaoCadastroArquivo } from 'src/app/models/opcao-cadastro-arquivo';
import { PedidoItem } from 'src/app/models/pedido';
import { PedidoCadastro, PedidoCadastroItemArquivo } from 'src/app/models/pedido-cadastro';
import { PedidoCadastroArquivo } from 'src/app/models/pedido-cadastro-arquivo';
import { Purchase } from 'src/app/models/purchase';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GestorService } from 'src/app/services/gestor.service';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-nova-compra-arquivo',
  templateUrl: './nova-compra-arquivo.component.html',
  styleUrls: ['./nova-compra-arquivo.component.css']
})
export class NovacompraArquivoComponent implements OnInit, AfterViewInit {
  // variáveis tabela
  public table: any;
  public tableHTML = 'tabela';

  // helper para tabela
  private headers: any[] = [];

  // variáveis
  public pedidoCadastro: PedidoCadastro;
  public opcoesArquivo: OpcaoCadastroArquivo[] = [];
  public opcaoArquivoSelecionado: OpcaoCadastroArquivo;

  private currentPurchaseValue: Purchase;
  private purchase: Purchase;

  public currentUser: Auth;
  public file: string;
  public download: SafeUrl;
  public autoAddColab: boolean = false;
  public grupo: Group = null;
  public gestorId;
  public cedenteId = 0;
  public productOfGroup: GroupProduct[];

  public produtos = [];
  public cedenteContratosId = [];
  public produtoCategoria = [];
  public taxaPedido = [];
  public flexValor = [];
  public flexIndividual = false;

  public tipoColaborador: number;
  campoFormulario: FormFields[];
  public collaboratorType: CollaboratorType[];
  public index = [1,5,0,4,0];

  public error = false;

  public pedidos: PedidoItem[];

  public accept = ['csv'];

  constructor(private pedidoDataService: PedidoDataService, private pedidoService: PedidoService,
              private alertService: NewAlertService, private authenticationService: AuthenticationService,
              private router: Router, private route: ActivatedRoute, private sanitizer: DomSanitizer,
              private grupoService: GroupService,
              private gestorService: GestorService,
              private productGroupService: ProductsGroupService,
              private arquivoService: ArquivoService) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    // recuperar pedido
    this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
    this.flexIndividual = this.currentPurchaseValue.flexIndividual;
    this.pedidoCadastro = this.pedidoDataService.currentPedidoValue;

    this.collaboratorType = JSON.parse(localStorage.getItem('collaboratorType'));
    this.tipoColaborador = this.collaboratorType[0].collaboratorTypeId;
    this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;

    if(this.currentPurchaseValue.purchaseItens.find(item => item.order.productCategory === 2) && !this.flexIndividual){
      if(this.currentPurchaseValue.group != null){
          this.grupo = new Group();
          this.grupo.id = this.currentPurchaseValue.group.groupId.toString();
          this.grupo.guidID = this.currentPurchaseValue.group.groupGuid;
      }else{
          this.grupo = this.grupoService.getGrupo();
      }
      this.gestorService.getAll(this.currentUser.token.assignorGuid).subscribe(
        response => {
            this.gestorId = response.result[0].gestorId;
            this.cedenteId = response.result[0].cedenteId;
            this.getProductsOfGroup(this.cedenteId)
        });
    }
    // carregar opções
    this.loadServices();

    this.loadHeaders();
    this.tipocolaborador(this.tipoColaborador);
  }

  getProductsOfGroup(cedenteId: number) {
    this.productGroupService.getGroupsByGroup(this.grupo.guidID, cedenteId).subscribe(res => {

        if (res.status === 1) {
            this.productOfGroup = [];
            this.productOfGroup = res.result;
        }

    });
}

  loadServices() {
    this.arquivoService.getOpcoesArquivo('pedido').subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.opcoesArquivo = response.result;
          this.setOpcaoPedidoArquivo(this.opcoesArquivo[0]);
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
  }


  setOpcaoPedidoArquivo(item: OpcaoCadastroArquivo) {
    this.opcaoArquivoSelecionado = item;
    this.download = this.downloadFile('CPF;Telefone;Valor*');
    // this.requiredFile(item);
  }

  requiredFile(item){
    if(item.Id == 1){
      let campos = item.urlArquivoExemplo.split(";");
      item.urlArquivoExemplo = '';
      this.campoFormulario.forEach( obj => {
        let i = this.index[obj.formFieldId-1];
        if(i != 0)
          campos[i-1] = obj.isStandard ? this.headers[i-1].title+"**" : this.headers[i-1].title ;
      });
      campos[1] = this.headers[1].title;
      campos[2] = this.headers[2].title;
      for(let i=0;i<campos.length;i++){
        item.urlArquivoExemplo += i<campos.length-1 ? campos[i]+';' : campos[i];
      };
      this.download = this.downloadFile(item.urlArquivoExemplo);
    }
  }

  ngAfterViewInit() {
    // this.table = this.loadjExcel(6, 10, this.tableHTML);
  }

  // construtor da tabel
  loadjExcel(numberOfCols: number, numberOfRows: number, tableHTML: string) {
    const collums: any = [];
    this.headers.forEach(element => {
      collums.push(element);
    });
    return jexcel(document.getElementById(tableHTML), {
      data: [[]],
      columns: collums,
      columnDrag: true,
      minDimensions: [numberOfCols, numberOfRows],
      defaultColWidth: 180,
      columnSorting: false,
      updateTable(instance, cell, col, row, val, label, cellName) {
        if (col === 0) {
          val.replace('-', '').replace('.', '');
          if (val.length < 11 && val.length > 0) {
            while (val.length < 11) {
              val = '0' + val;
            }
            val = val.slice(0, 3) + '.' + val.slice(3, 6) + '.' + val.slice(6, 9) + '-' + val.slice(9, 11);
            cell.innerHTML = val;
          }
        }
      },
      //#region Tradução
      text: {
        noRecordsFound: 'Nenhum registro encontrado',
        showingPage: 'Mostrando página {0} de {1} entradas',
        show: 'Show',
        entries: 'entradas',
        insertANewColumnBefore: 'Inserir uma nova coluna antes de',
        insertANewColumnAfter: 'Inserir uma nova coluna depois de',
        deleteSelectedColumns: 'Excluir colunas selecionadas',
        renameThisColumn: 'Renomear esta coluna',
        orderAscending: 'ordem ascendente',
        orderDescending: 'Order decrescente',
        insertANewRowBefore: 'Inserir uma nova linha antes de',
        insertANewRowAfter: 'Inserir uma nova linha depois de',
        deleteSelectedRows: 'Excluir linhas selecionadas',
        editComments: 'Editar comentários',
        addComments: 'Adicionar comentários',
        comments: 'Comentários',
        clearComments: 'Limpar comentários',
        copy: 'Copiar ...',
        paste: 'Colar ...',
        saveAs: 'Salvar como ...',
        about: 'About',
        areYouSureToDeleteTheSelectedRows: 'Tem certeza de excluir as linhas selecionadas?',
        areYouSureToDeleteTheSelectedColumns: 'Tem certeza de excluir as colunas selecionadas?',
        // tslint:disable-next-line: max-line-length
        thisActionWillDestroyAnyExistingMergedCellsAreYouSure: 'Esta ação irá destruir todas as células mescladas existentes. Você tem certeza?',
        thisActionWillClearYourSearchResultsAreYouSure: 'Esta ação limpará seus resultados de pesquisa. Você tem certeza?',
        thereIsAConflictWithAnotherMergedCell: 'Há um conflito com outra célula mesclada',
        invalidMergeProperties: 'Propriedades mescladas inválidas',
        cellAlreadyMerged: 'Célula já mesclado',
        noCellsSelected: 'Nenhuma célula selecionada',
        update: 'Atualizar',
        reset: 'Limpar',
        done: 'Pronto'

      }
      //#endregion
    });
  }

  loadHeaders() {
    let index = 0;
    this.headers.push({
      title: 'CPF',
      colspan: '1',
      type: 'text',
      mask: '000.000.000-00',
      id: index
    }); index++;

    // this.headers.push({
    //   title: 'Nome**',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); index++;

    // this.headers.push({
    //   title: 'Sobrenome**',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); index++;

    // this.headers.push({
    //   title: 'Data de nascimento',
    //   colspan: '1',
    //   type: 'text',
    //   mask: '00/00/0000',
    //  /*  options : {
    //     months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    //     weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    //     weekdays_short: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
    // }, */
    //   id: index
    // }); index++;

    this.headers.push({
      title: 'Telefone',
      colspan: '1',
      type: 'number',
      mask: '(00) 00000-0000',
      id: index
    }); index++;

    this.headers.push({
      title: 'Valor*',
      colspan: '1',
      type: 'numeric',
      mask: 'R$ #.##0,00',
      decimal: ',',
      id: index
    }); index++;

    // this.headers.push({
    //   title: 'Matrícula',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); index++;

    // this.headers.push({
    //   title: 'Centro de custo',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); index++;

    // this.headers.push({
    //   title: 'Departamento',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); index++;

    // this.headers.push({
    //   title: 'Unidade',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // });

    this.table = this.loadjExcel(3, 10, this.tableHTML);
  }

  continuar() {
    const tipoColab = this.collaboratorType.find(x => x.collaboratorTypeId == this.tipoColaborador);
    const idOpacaoPedidoArquivo = this.opcaoArquivoSelecionado.Id;
    const cedenteGuid = this.currentUser.token.assignorGuid;
    const gestorGuid = this.currentUser.token.userReferenceId;
    let items = [];
    if(this.opcaoArquivoSelecionado.Id === 2){
      items = this.getItems(this.table.getJson());
    }
    const file = this.file;
    this.produtos = [];
    this.cedenteContratosId = [];
    this.produtoCategoria = [];
    this.taxaPedido = [];
    this.flexValor = [];

    if (this.error) {
      return;
    }

    if (!file && this.opcaoArquivoSelecionado.Id === 1) {
      this.alertService.error('Todos os campos estão vazios');
      return;
    }

    if (items.length === 0 && this.opcaoArquivoSelecionado.Id === 2) {
      this.alertService.error('Todos os campos estão vazios');
      return;
    }

    if(this.productOfGroup == null){
      for(let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
        this.produtos.push(this.currentPurchaseValue.purchaseItens[i].productId);
        // this.cedenteContratosId.push(this.currentPurchaseValue.purchaseItens[i].order.assignorContractId);
        // this.produtoCategoria.push(this.currentPurchaseValue.purchaseItens[i].order.productCategory);
        // this.taxaPedido.push(this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent);
      }
    } else {
      for(let i = 0; i < this.productOfGroup.length; i++) {
        // this.flexValor.push(this.productOfGroup[i].value);
        this.produtos.push(this.productOfGroup[i].productID);
        // this.cedenteContratosId.push(this.productOfGroup[i].assignorContractId);
        // this.produtoCategoria.push(this.productOfGroup[i].productCategory);
        // this.taxaPedido.push(0);
      }

    }

    // const pedido = new PedidoCadastroArquivo(
    //   items,
    //   file,
    //   this.produtos,
    //   this.cedenteContratosId,
    //   this.produtoCategoria,
    //   this.taxaPedido,
    //   this.grupo? +this.grupo.id : null,
    //   this.autoAddColab,
    //   this.flexValor,
    //   tipoColab
    // );

    const pedido = new PurchaseFile(
      items,
      file,
      this.produtos,
      this.grupo? +this.grupo.id : null
    );

    
    this.pedidoService.CreatePurchaseByFile(cedenteGuid, gestorGuid, pedido).subscribe(res => {
      if (res.status === ApiError.Sucesso) {
        this.alertService.success(res.message);
        this.router.navigate([`arquivo-confimar/${res.result.batchId}`], { queryParams: { purchase: res.result.purchaseId }, relativeTo: this.route.parent });
      } else {
        this.alertService.error(res.message);
      }
    });
  }

  getItems(json: any): PedidoCadastroItemArquivo[] {

    const items: PedidoCadastroItemArquivo[] = [];

    this.error = false;

    json.forEach((element, index) => {

      /*if (this.validaCampo(0) && element['0'] === '' && !this.isEmpty(element)) {
        this.alertService.error('CPF inválido. Linha ' + (index + 1));
        this.error = true;
      } else*/ if (!Number(element['2'].replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) && !this.isEmpty(element)) {
        this.alertService.error('Valor inválido. Linha ' + (index + 1));
        this.error = true;
      } /*else if (this.validaCampo(3) && !this.isDate(element['3']) && element['3']!="" && !this.isEmpty(element)) {
        this.alertService.error('Data de nascimento inválida. Linha ' + (index + 1));
        this.error = true;
      } else if (this.validaCampo(4) && !Number(element['4'].replace(/[^\d]+/g,'')) && !this.isEmpty(element)) {
       this.alertService.error('Telefone obrigatório. Linha ' + (index + 1));
       this.error = true;
      }* / else*/ if (/*element['0'] !== '' &&*/ Number(element['2'].replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) && !this.error && !this.isEmpty(element)) {
        const cpf = element['0'].replace(/\D/g, '');

        // const item = new PedidoCadastroItemArquivo(cpf, element['1'], element['2'],
        //   this.formatDate(element['3']), Number(element['4'].replace(/[^\d]+/g,'')), Number(element['5']), element['6'], element['7'], element['8'], element['9']);

          const item = new PedidoCadastroItemArquivo(cpf, null, null, null,  Number(element['1'].replace(/\D/g, '').trim()), Number(element['2'].replace('R$', '').replace(/\./g, '').replace(',', '.').trim()), null, null, null, null);

          items.push(item);
      }
    });

    return items;
  }

  validaCampo(i){
    return this.campoFormulario.some(x => x.formFieldId == (this.index.indexOf(i+1)+1) && x.isStandard);
  }

  isEmpty(elem: any) {
    return elem['0'] === '' && elem['1'] === '' && elem['2'] === '';

    // return elem['0'] === '' && elem['1'] === '' && elem['2'] === '' && elem['3'] === '' &&
    // elem['4'] === '' && elem['5'] === '' && elem['6'] === '' && elem['7'] === '' && elem['8'] === '';
  }

  isDate(data: any){
    var RegExPattern = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])      [\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (!((data.match(RegExPattern)) && (data!=''))) {
      return false
    } else {
      return true
    }
  }

  formatDate(date: string) {
    const dateArray = date.split('/');
    if (!dateArray || dateArray.length !== 3 || dateArray.some(x => !Number(x))) {
      return null
    }
    return new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
  }

  setFile(file: any): void {
    this.file = file;
    if (!file) {
      this.alertService.error('Formato de arquivo não suportado!');
      this.alertService.error('Formatos aceitos: CSV');
    }
  }

  downloadFile(data: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    return this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
  }

  onAutoAddColabChanged(value:boolean){
    this.autoAddColab = value;
  }

  tipocolaborador(v: number, toggle: boolean = false){
    if(v == 1)
    {
      this.tipoColaborador = 1;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 2){
      this.tipoColaborador = 2;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 3){
      this.tipoColaborador = 3;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 4){
      this.tipoColaborador = 4;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    // this.setTableHeader();
    // this.requiredFile(this.opcaoArquivoSelecionado);
  }

  setTableHeader() {
    this.campoFormulario.forEach( obj => {
      let i = this.index[obj.formFieldId-1];
      if(i != 0)
        document.getElementsByTagName("table")[0].rows[0].cells[i].innerHTML = obj.isStandard ? this.headers[i-1].title+"**" : this.headers[i-1].title;
    });
  }
}
